import { render, staticRenderFns } from "./HelpCenterWrapper.vue?vue&type=template&id=5b341a1c&scoped=true&"
import script from "./HelpCenterWrapper.vue?vue&type=script&lang=js&"
export * from "./HelpCenterWrapper.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterWrapper.vue?vue&type=style&index=0&id=5b341a1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b341a1c",
  null
  
)

export default component.exports